import React from 'react';

import { Link } from 'react-router-dom';
import { Paths } from '../../../../shared/paths';
import { AvatarTypes } from '../../../designe/app-avatar/AppAvatar';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../designe/app-entity-avatar/AppEntityAvatar';
import theme from '../../../../styles/theme';
import clsx from 'clsx';
import { useStyles } from './CommunitySmallItem.styles';
import { ICommunity } from '../../../../types/interfaces/community';

interface ICommunitySmallItem {
  community: ICommunity;
}

export default function CommunitySmallItem(props: ICommunitySmallItem) {
  const { community } = props;
  const { classes } = useStyles(theme);

  return (
    <Link
      to={`${Paths.communities.root}/${community.id}`}
      className={clsx(classes.communityWrapper)}>
      <AppEntityAvatar
        entity={community}
        size={AvatarSize.m}
        type={AvatarTypes.round}
      />
      <div className={classes.infoWrapper}>
        <div className={classes.infoName}>{community.title}</div>
      </div>
    </Link>
  );
}
